import React from 'react';
import classNames from 'classnames';
import { Typography } from '../typography/typography';
import Circle from './assets/circle.svg?react';
// Re-use styles because skeleton is considered special instance of tag and the alternative would be to create the components in the same file
import styles from './tag.module.scss';

/**
 * Loading skeleton for the Tag component. The height must be the same as the Tag component.
 * @constructor
 */
export const TagSkeleton: React.FC = () => {
  return (
    <span className={classNames(styles.root)}>
      <Circle className={classNames(styles.icon, styles.skeleton)} />
      <Typography tag="span" variant="smalltext">
        &nbsp;
      </Typography>
    </span>
  );
};
